import {getAuth, sendPasswordResetEmail, signInWithEmailAndPassword} from '@firebase/auth';
import {initializeApp} from 'firebase/app';
import FirebaseResponse from "./FirebaseResponse";

export default class FirebaseAuthenticationMethod {
    constructor() {
        const firebaseConfig = {
            apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FIREBASE_APP_ID,
        };

        const app = initializeApp(firebaseConfig);

        this._auth = getAuth(app);
        this._application = null;
    }

    withApplication(application) {
        this._application = application
    }

    async createUser(email) {
        try {
            await sendPasswordResetEmail(this._auth, email);
            return new FirebaseResponse()
        } catch (error) {
            return new FirebaseResponse(undefined, true, error.message)
        }
    };

    subscribeToAuthEvents() {
        return new Promise((resolve) => {
            this._auth.onAuthStateChanged(async (firebaseUser) => {
                const token = await this._updateUserTokenFromFirebaseUser(firebaseUser);
                this._application.session().addToken(token)
                resolve();
            });
            this._auth.onIdTokenChanged(async (firebaseUser) => {
                const token = await this._updateUserTokenFromFirebaseUser(firebaseUser);
                this._application.session().addToken(token)
                resolve();
            });
        });
    }

    async _updateUserTokenFromFirebaseUser(firebaseUser) {
        if (firebaseUser) {
            return await this._updateUserToken(firebaseUser);
        }
    }

    async signIn(email, password) {
        try {
            const result = await signInWithEmailAndPassword(this._auth, email, password)
            const token = await result.user.getIdToken();
            return new FirebaseResponse(token, false, '')
        } catch (error) {
            return new FirebaseResponse(undefined, true, error.message)
        }
    }

    async signOut() {
        return await this._auth.signOut();
    }

    isUserLoggedIn() {
        const currentUser = this.user();
        return currentUser !== null;
    }

    user() {
        return this._auth.currentUser;
    }

    async refreshUserToken() {
        const firebaseUser = this.user();
        if (firebaseUser === null) {
            return;
        }
        await this._updateUserToken(firebaseUser, true);
    }

    async _updateUserToken(firebaseUser, forceRefresh = false) {
        return await this._getUserToken(firebaseUser, forceRefresh)
    }

    async _getUserToken(firebaseUser, forceRefresh = false) {
        return await firebaseUser.getIdToken(forceRefresh);
    }

    recoverPassword(email) {
        return sendPasswordResetEmail(this._auth, email)
    }
}